import { observer } from "mobx-react";
import moment from "moment";
import * as React from "react";

import DetailsPageFields, {
  FieldType as DetailsField,
} from "@client/components/modules/DetailsPage/Fields";
import TagGroup from "@client/components/ui/TagGroup";
import { isLocationAvailable } from "@client/utils/Constants";
import countries from "@server/CountriesList";
import { Customer } from "@typings/Customer";
import { TokenInfo } from "@typings/Identity";
import { Licence } from "@typings/Licence";
import { Licensor } from "@typings/Licensor";
import { Tag } from "@typings/Tag";

type Props = {
  customer: Customer | null;
  tags: Tag[];
  licences: Licence[];
  tokenInfo: TokenInfo | null;
  licensors: Licensor[];
};

@observer
class DetailsFields extends React.Component<Props> {
  render() {
    const { customer, tokenInfo, licensors } = this.props;
    const licensorRecord = customer?.created_by
      ? licensors.find(
          l =>
            l.name === customer.created_by || l.email === customer.created_by,
        )
      : undefined;
    const countryItem: { name: string; code: string } | undefined =
      countries.find(c => (customer ? c.code === customer.country : null));
    let country: string | null = null;
    if (!countryItem) {
      country = customer?.country || null;
    } else {
      country = countryItem.name;
    }

    const fields: DetailsField[] = [
      {
        label: "Name",
        value: customer?.name,
      },
      {
        label: "ID",
        value: customer?.id,
      },
      {
        label: "Description",
        value: customer?.description,
      },
      {
        label: "Created At",
        value: moment(customer?.created_at).format("DD MMM YYYY HH:mm"),
      },
      {
        label: "Licencing Email",
        value: customer?.email,
      },
      {
        label: "License Manager",
        value: customer?.created_by,
        link:
          isLocationAvailable("/licensors", tokenInfo) && licensorRecord
            ? `/licensors/${licensorRecord.id}`
            : null,
      },
      {
        label: "Country",
        value: country,
      },
      {
        label: "Department",
        value: customer?.department,
      },
      {
        label: "Contact Person",
        value: customer?.contact,
      },
      {
        label: "Licences Tags",
        value: customer ? (
          <TagGroup
            licences={this.props.licences.filter(
              l => l.customer_id === customer!.id,
            )}
            tags={this.props.tags}
          />
        ) : null,
        useFullWidth: true,
      },
    ];

    return <DetailsPageFields fields={fields} />;
  }
}

export default DetailsFields;
